import { Typography, Card, CardContent, Box, Link, Button } from '@mui/material';
import { ArrowForwardIos } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import { useGetJobseekerSavedPostsRecentQuery } from '@carcareers/store';
import { CardLoader } from '@carcareers/components';
import { SavedJob } from '@libs/models';
import { routes } from '@carcareers/utils';

export const SavedPostsCard = () => {
  const navigate = useNavigate();
  const { data: savedPosts, isLoading } = useGetJobseekerSavedPostsRecentQuery();

  return (
    <Card elevation={0} sx={{ borderRadius: 4, border: '1px solid', borderColor: 'divider' }}>
      <CardContent sx={{ p: '16px !important' }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Saved Posts
        </Typography>
        {isLoading ? (
          <CardLoader />
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {savedPosts?.meta.totalItems === 0 ? (
              <Typography variant="body2" color="text.secondary">
                No posts saved yet.
              </Typography>
            ) : (
              savedPosts?.items.map((savedJob: SavedJob) => (
                <Link
                  key={`saved-${savedJob.id}`}
                  href={`/${routes.JOBSEEKERS}/${savedJob.post?.id}`}
                  sx={{
                    textDecoration: 'none',
                    color: 'inherit',
                    display: 'block',
                    py: 1,
                    px: 2,
                    borderRadius: 4,
                    '&:hover': {
                      backgroundColor: 'action.hover',
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Box>
                      <Typography variant="subtitle2" sx={{ fontWeight: 'medium' }}>
                        {savedJob.post?.job?.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Saved {new Date(savedJob.savedAt).toLocaleDateString()}
                      </Typography>
                    </Box>
                    <ArrowForwardIos sx={{ fontSize: 16, color: 'text.secondary' }} />
                  </Box>
                </Link>
              ))
            )}
            {savedPosts?.meta?.totalItems && savedPosts?.meta?.totalItems > 3 ? (
              <Button
                size="small"
                color="primary"
                onClick={() => navigate(`/${routes.JOBSEEKER_HOME}/saved`)}
                sx={{
                  borderRadius: 4,
                }}
              >
                View All Saved Jobs
              </Button>
            ) : null}
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
